import {
  UserManager,
  WebStorageStateStore,
  User,
  UserManagerSettings
} from 'oidc-client';
import store from '@/store';

/**
 * Provides helper methods around the oidc-client userManager instance.
 */
export default class AuthService {
  private userManager: UserManager;

  public constructor() {
    const STS_DOMAIN: string = window.location.origin;

    const settings: UserManagerSettings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: STS_DOMAIN,
      client_id: 'pmo_local_dev',
      redirect_uri: `${STS_DOMAIN}/callback.html`,
      automaticSilentRenew: true,
      silent_redirect_uri: `${STS_DOMAIN}/silent-renew.html`,
      response_type: 'code',
      scope: 'openid profile pmo.api.full_access',
      post_logout_redirect_uri: `${STS_DOMAIN}/account/login`,
      filterProtocolClaims: true
    };

    this.userManager = new UserManager(settings);

    this.userManager.events.addUserLoaded((user) => {
      // update the store with latest token and display name
      // this occurs on successful silent renewals
      store.commit('setUser', user);
      console.log('User Loaded, stored to vuex.');
    });

    this.userManager.events.addSilentRenewError((...args) => {
      console.error('Silent Renew Error: ', JSON.stringify(args));
      this.login();
    });

    this.userManager.events.addAccessTokenExpiring((...args) => {
      console.log('AccessToken Expiring: ', args);
    });
  }

  /**
   * get the user (Profile) from the user service.
   */
  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  /**
   * performs the login redirect
   */
  public login(): Promise<void> {
    // use state to send location prior to redirect
    // inspired and copied from: https://stackoverflow.com/a/54629431/86860
    return this.userManager.signinRedirect({ state: window.location.href });
  }

  /**
   * performs the logout redirect
   */
  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  /**
   * return an access token for the signed in user.
   */
  public getAccessToken(): Promise<string> {
    return this.userManager.getUser().then((data) => {
      if (data && data.access_token) {
        return data.access_token;
      }
      return '';
    });
  }
}
